import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AdditionalbaseService } from './services/common/additionalbase.service';
import { CanActivateService } from './services/common/can.active.service';
import { EncryptedService } from './services/common/encrypted.services';
import { NotifyService } from './services/notify/notify.service';
import { BreadCrumbsService } from './services/common/breadcrumbs.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { TemplateComponent } from './shared/template/template.component';
import { MaterialModule } from './shared/material.module';
import { CommonService } from './services/common/common.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpRequest } from '@angular/common/http';
import { LoaderService } from './services/common/loader.service';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { RecuperarComponent } from './modules/general/dialogs/recuperar/recuperar.component';
import { HttpRequestInterceptor } from './interceptors/http-request.interceptor';
// import { LoginComponent } from './modules/general/login/login.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    TemplateComponent,
    RecuperarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      primaryColour: '#00aef0',
      secondaryColour: '#00aef0',
      tertiaryColour: '#00aef0',
      fullScreenBackdrop: true,
    }),
    
  ],
  providers: [
    CommonService,
    CanActivateService,
    BreadCrumbsService,
    EncryptedService,
    AdditionalbaseService,
    NotifyService,
    // DateHandler
    {
      provide: 'CanAlwaysActivateGuard',
      useValue: () => {
        return true;
      }
    },
    {
      provide: '',
      useValue: () => true
    },
    { provide: LOCALE_ID, useValue: 'en-US' },
    LoaderService,
    { provide: LocationStrategy, useClass: HashLocationStrategy},

    // interceptors
    {
      provide:HTTP_INTERCEPTORS,
      multi:true,
      useClass:HttpRequestInterceptor
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
